module.exports = __webpack_public_path__ + "static/media/header-item-collections.98241e84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/header-item-collections.svg
// module id = 1456
// module chunks = 0